import type { RentalTemplateContextConfig } from "#lib/web-ui/rental/index.js";
import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

export const parkwoodSiteConfig: RentalTemplateContextConfig = {
	name: "Parkwood Apartments",
	tagline: "YOUR OASIS IN VICTORIA",
	logo: cloudinaryUrl("brand/parkwood/parkwood-long-dark", { width: 300 }),
	address: {
		street: "3001 Arroyo Dr",
		city: "Victoria",
		state: "TX",
		zip: "77901"
	},
	geo: {
		latitude: "28.8228573",
		longitude: "-96.9984018"
	},
	amenities: [
		"Swimming Pool",
		"Laundry Facilities",
		"Pet Friendly",
		"Parking",
		"Fireplace",
		"Courtyard"
	],
	priceRange: "$$",
	metaDescription:
		"Discover Parkwood Apartments in Victoria, TX - your serene oasis featuring spacious 1-2 bedroom apartments with granite countertops, oversized closets, and wood plank flooring. Enjoy our swimming pool, on-site management, and prime location near Texas A&M University-Victoria and Victoria College.",
	metaKeywords:
		"Parkwood Apartments, apartments Victoria TX, Victoria TX apartments, apartments for rent Victoria TX, 1 bedroom apartments Victoria TX, 2 bedroom apartments Victoria TX, apartments 77901, Arroyo Dr apartments, apartments near Texas A&M University-Victoria, apartments near University of Houston Victoria, apartments near Victoria College, pet-friendly apartments Victoria TX, apartments with pool Victoria TX, apartments with private patios Victoria TX, apartments with balconies Victoria TX, apartments with on-site laundry Victoria TX, apartments with granite countertops Victoria TX, apartments with wood plank flooring Victoria TX, apartments with fireplace Victoria TX, apartments with washer dryer connections Victoria TX, spacious apartments Victoria TX, quiet apartments Victoria TX, luxury apartments Victoria TX, Victoria Texas rentals, Parkwood Apartments rentals, apartments near downtown Victoria TX, apartments near Victoria Mall, apartments near Riverside Park, The Ash floor plan, The Oak floor plan, The Birch floor plan, The Pine floor plan",

	buildiumPropertyIds: ["104758"],
	tenantPortal: "https://fergmar.managebuilding.com/Resident/portal/",
	contact: {
		phone: "361-200-1813",
		email: "leasing@liveatparkwood.com"
	},
	events: [],
	eventImage: cloudinaryUrl("www/liveatparkwood-com/pool", { width: 800 }),
	websiteUrl: "liveatparkwood.com",
	socialMedia: {
		facebook: "https://facebook.com/parkwoodapartments",
		instagram: "https://instagram.com/parkwoodapartments"
	},
	heroImage: cloudinaryUrl("www/liveatparkwood-com/parkwood-trees", { width: 1920 }),
	heroVideoPublicId: "www/liveatparkwood-com/background-video",
	apartmentFeatures: [
		"Spacious 1 and 2 Bedroom Floor Plans",
		"Fully Equipped Kitchens",
		"Black Appliance Package",
		"Beautiful Granite Countertops",
		"Oversized Closets",
		"Walk-In Closets",
		"Washer & Dryer Connections",
		"Wood Plank Flooring",
		"Tile Flooring",
		"Fireplace",
		"Two-Inch Blinds",
		"Ceiling Fans in Bedrooms"
	],
	communityFeatures: [
		"Located in the Heart of Victoria, TX",
		"Small, Quiet Neighborhood",
		"Nearby Cultural Centers of Victoria",
		"Convenient Access to Schools and Shopping",
		"Relaxing Swimming Pool with Sun Deck",
		"Relaxed Courtyard",
		"On-Site Laundry Center",
		"On-Call Maintenance",
		"On-Site Management"
	],
	detailsImage: cloudinaryUrl("www/liveatparkwood-com/parkwood-trees", { width: 800 }),
	neighborhood: [
		"Minutes from downtown",
		"Riverside Park",
		"The Texas Zoo",
		"Riverside Golf Course",
		"Rose Garden",
		"Theatre Victoria",
		"Victoria Mall",
		"Close to businesses and restaurants",
		"By Victoria College and University of Houston",
		"Home to the Victoria Independent School District"
	],
	floorPlans: [
		{
			key: "the-ash",
			name: "The Ash",
			beds: 1,
			baths: 1,
			sqFt: { min: 660, max: 660 },
			image: cloudinaryUrl("www/liveatparkwood-com/ash-floorplan", { width: 600 }),
			deposit: null
		},
		{
			key: "the-oak",
			name: "The Oak",
			beds: 2,
			baths: 1,
			sqFt: { min: 850, max: 850 },
			image: cloudinaryUrl("www/liveatparkwood-com/oak-floorplan", { width: 600 }),
			deposit: null
		},
		{
			key: "the-birch",
			name: "The Birch",
			beds: 2,
			baths: 2,
			sqFt: { min: 950, max: 950 },
			image: cloudinaryUrl("www/liveatparkwood-com/birch-floorplan", { width: 600 }),
			deposit: null
		},
		{
			key: "the-pine",
			name: "The Pine",
			beds: 2,
			baths: 2,
			sqFt: { min: 1055, max: 1055 },
			image: cloudinaryUrl("www/liveatparkwood-com/pine-floorplan", { width: 600 }),
			deposit: null
		}
	],
	propertyImages: [
		{
			url: cloudinaryUrl("www/liveatparkwood-com/community", { width: 1200 }),
			alt: "Apartment exterior"
		},
		{
			url: cloudinaryUrl("www/liveatparkwood-com/pool", { width: 1200 }),
			alt: "Swimming pool"
		},
		{
			url: cloudinaryUrl("www/liveatparkwood-com/dog-park", { width: 1200 }),
			alt: "Dogpark"
		}
	],
	welcomeTagline: "WHERE COMFORT MEETS CONVENIENCE",
	welcomeDescription:
		"Discover Parkwood Apartments, where comfort and convenience meet in Victoria, Texas. Nestled off Navarro on Arroyo Dr, our community provides easy access to dining, shopping, and recreation. Choose from a variety of floor plans, each featuring private patios or balconies and cozy fireplaces. Enjoy amenities like our swimming pool, sun deck, and beautiful courtyard, along with on-site laundry and maintenance services. Plus, Parkwood Apartments is pet-friendly, welcoming both cats and dogs. With its ideal location near the University of Houston – Victoria, our community offers a quiet retreat just minutes from campus. Experience the perfect blend of comfort, convenience, and community at Parkwood Apartments —your new home awaits."
} as const;
